import { atom } from "recoil";

// 医療機関マスタの医療コースサービス
export const clinicServiceState = atom({
  key: "clinicServiceState",
  default: {
    id: null,
    clinic_id: null,
    cource_type: null,
    enabled: null,
    base_price: null,
    dock_barium_price: null,
    dock_mouth_price: null,
    dock_nose_price: null,
    select_barium_price: null,
    select_mouth_price: null,
    select_nose_price: null,
    anesthesia_note: null,
  },
});